const currencies = [
  'afn',
  'eur',
  'all',
  'dzd',
  'usd',
  'eur',
  'aoa',
  'xcd',
  'xcd',
  'ars',
  'amd',
  'awg',
  'aud',
  'eur',
  'azn',
  'bsd',
  'bhd',
  'bdt',
  'bbd',
  'byn',
  'eur',
  'bzd',
  'xof',
  'bmd',
  'inr',
  'btn',
  'bob',
  'bov',
  'usd',
  'bam',
  'bwp',
  'nok',
  'brl',
  'usd',
  'bnd',
  'bgn',
  'xof',
  'bif',
  'cve',
  'khr',
  'xaf',
  'cad',
  'kyd',
  'xaf',
  'xaf',
  'clp',
  'clf',
  'cny',
  'aud',
  'aud',
  'cop',
  'cou',
  'kmf',
  'cdf',
  'xaf',
  'nzd',
  'crc',
  'xof',
  'hrk',
  'cup',
  'cuc',
  'ang',
  'eur',
  'czk',
  'dkk',
  'djf',
  'xcd',
  'dop',
  'usd',
  'egp',
  'svc',
  'usd',
  'xaf',
  'ern',
  'eur',
  'etb',
  'eur',
  'fkp',
  'dkk',
  'fjd',
  'eur',
  'eur',
  'eur',
  'xpf',
  'eur',
  'xaf',
  'gmd',
  'gel',
  'eur',
  'ghs',
  'gip',
  'eur',
  'dkk',
  'xcd',
  'eur',
  'usd',
  'gtq',
  'gbp',
  'gnf',
  'xof',
  'gyd',
  'htg',
  'usd',
  'aud',
  'eur',
  'hnl',
  'hkd',
  'huf',
  'isk',
  'inr',
  'idr',
  'xdr',
  'irr',
  'iqd',
  'eur',
  'gbp',
  'ils',
  'eur',
  'jmd',
  'jpy',
  'gbp',
  'jod',
  'kzt',
  'kes',
  'aud',
  'kpw',
  'krw',
  'kwd',
  'kgs',
  'lak',
  'eur',
  'lbp',
  'lsl',
  'zar',
  'lrd',
  'lyd',
  'chf',
  'eur',
  'eur',
  'mop',
  'mkd',
  'mga',
  'mwk',
  'myr',
  'mvr',
  'xof',
  'eur',
  'usd',
  'eur',
  'mru',
  'mur',
  'eur',
  'xua',
  'mxn',
  'mxv',
  'usd',
  'mdl',
  'eur',
  'mnt',
  'eur',
  'xcd',
  'mad',
  'mzn',
  'mmk',
  'nad',
  'zar',
  'aud',
  'npr',
  'eur',
  'xpf',
  'nzd',
  'nio',
  'xof',
  'ngn',
  'nzd',
  'aud',
  'usd',
  'nok',
  'omr',
  'pkr',
  'usd',
  'pab',
  'usd',
  'pgk',
  'pyg',
  'pen',
  'php',
  'nzd',
  'pln',
  'eur',
  'usd',
  'qar',
  'eur',
  'ron',
  'rub',
  'rwf',
  'eur',
  'shp',
  'xcd',
  'xcd',
  'eur',
  'eur',
  'xcd',
  'wst',
  'eur',
  'stn',
  'sar',
  'xof',
  'rsd',
  'scr',
  'sll',
  'sgd',
  'ang',
  'xsu',
  'eur',
  'eur',
  'sbd',
  'sos',
  'zar',
  'ssp',
  'eur',
  'lkr',
  'sdg',
  'srd',
  'nok',
  'szl',
  'sek',
  'chf',
  'che',
  'chw',
  'syp',
  'twd',
  'tjs',
  'tzs',
  'thb',
  'usd',
  'xof',
  'nzd',
  'top',
  'ttd',
  'tnd',
  'try',
  'tmt',
  'usd',
  'aud',
  'ugx',
  'uah',
  'aed',
  'gbp',
  'usd',
  'usd',
  'usn',
  'uyu',
  'uyi',
  'uyw',
  'uzs',
  'vuv',
  'ves',
  'vnd',
  'usd',
  'usd',
  'xpf',
  'mad',
  'yer',
  'zmw',
  'zwl',
  'xba',
  'xbb',
  'xbc',
  'xbd',
  'xts',
  'xxx',
  'xau',
  'xpd',
  'xpt',
  'xag',
];

export default currencies;
